import { ACTION_TYPES } from './store/actions';
import { rulesApi } from '../api';
import { RulesContext } from '../domain/RulesContext';

export const getAppDataConf = (rulesContext: RulesContext) => async (dispatch, getState) => {
  const { dataConfList } = getState().rules;

  if (!dataConfList.has(rulesContext.key)) {
    await dispatch({
      type: ACTION_TYPES.GET_APP_DATA_CONF,
      payload: rulesApi.getAppDataConf(rulesContext)
    });
  }
};

export const getDataView = (rulesContext: RulesContext) => async (dispatch, getState) => {
  const { dataViewList } = getState().rules;

  if (!dataViewList.has(rulesContext.entryDataRules.view)) {
    await dispatch({
      type: ACTION_TYPES.GET_DATA_VIEW,
      payload: rulesApi.getAppDataConf(rulesContext)
    });
  }
};
